/* eslint-disable react/jsx-key */
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from 'react'
import * as ScreenPermissions from 'core/EventActions'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, ExportComponent } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  getUnitLockCheckRelease,
  postUnitLockRelease,
  deleteUnitLockRelease,
  getMonthlyLock,
  getVerificationLock,
} from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getPermitActions,
  getEnvConfig,
  getClientInfo,
} from 'core/selectors'
// import ErrorModal from 'core/component/ErrorModal'

import styled from 'styled-components'
import { Button, Input, DatePicker, Select, message, Popconfirm } from 'antd'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  freeEditEngine,
} from '@integec/grid-tools'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
  sortStringArray,
} from 'core/utils'
import moment from 'moment'
import { ErrorContext, SpinContext } from 'context'
import { MISO_CLIENT, PJM_CLIENT } from 'client'

const TableTD = styled.td`
  text-align: end;
  display: grid;
  align-content: center;
`

const retrieveTask = apiTargetInfo => getUnitLockCheckRelease(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postUnitLockRelease(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteUnitLockRelease(apiTargetInfo)(data)

const headers = [
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'releaseUntil',
    display: 'Release Until',
    isKey: false,
    dataFormat: 'MM/DD/YYYY',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'lockName',
    display: 'Lock Type',
    isKey: true,
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const title = 'Lock Release'

const UnitLock = ({ apiTargetInfo, CLIENT, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [monthlyLock, setMonthlyLock] = useState([])
  const [pjmVerificationLockList, setMonthlyVerificationLock] = useState([])
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  useEffect(() => {
    getMonthlyLock(apiTargetInfo).fork(setError, data => {
      setMonthlyLock(data.map(d => d.monthlyLock).sort())
    })

    if (CLIENT === PJM_CLIENT || CLIENT === MISO_CLIENT) {
      getVerificationLock(apiTargetInfo).fork(setError, data => {
        setMonthlyVerificationLock(data.map(d => d.lockName).sort())
      })
    }
  }, [apiTargetInfo, setError, CLIENT])

  const { utilityNameMap, unitNameMap } = props

  const utilitysortOpt = (a, b) =>
    (utilityNameMap[a] || a).localeCompare(utilityNameMap[b] || b)
  const unitsortOpt = (a, b) =>
    (unitNameMap[a] || '').localeCompare(unitNameMap[b])

  const [insertData, setInsertData] = useState({})
  const onAdd = bool => {
    if (
      insertData.unit &&
      insertData.utility &&
      insertData.lockName &&
      insertData.releaseUntil
    ) {
      setSpinning(true)
      modifyTask(apiTargetInfo)([insertData]).fork(setError, _ => {
        setSpinning(false)
        setInsertEvent(bool)
        setInsertData({})
        onRetrieveData()
      })
    } else {
      message.error('Some of required field are null')
    }
  }

  const onCancel = _ => {
    setInsertData({})
    setInsertEvent(false)
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          // dataFormatter: ({ value }) =>
          //   CLIENT === BROOKFIELD_CLIENT
          //     ? value + ' - ' + utilityNameMap[value]
          //     : utilityNameMap[value] || value,
          dataFormatter: ({ value }) => value + ' - ' + utilityNameMap[value],
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          // dataGetter: this.generateDataGetter,
          dataFormatter: ({ value }) =>
            value.substr(value.length - 3) === 'ALL'
              ? 'ALL-ALL Units'
              : value
              ? (value + '').substr(3) + ' - ' + unitNameMap[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : /*: header.ident === 'effectiveMonth'
        ? {
            ...header,
            choices: mo nthOption,
          } */
        header
  )
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const GridRef = useRef()
  const [data, setData] = useState([])
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const [selectedRows, setSelectedRows] = useState([])

  const selectionChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  const isEditable = ({ header }) => {
    if (header.ident === 'modifier' || header.ident === 'modifiedDate')
      return false
    return !header.isKey || header.isEditable || false
  }
  const clearData = _ => {
    setData([])
    setEditInfo(freeEditEngine.generateInitialEditInfo())
  }

  const onInsert = _ => {
    setInsertEvent(true)
  }

  const onRetrieveData = useCallback(
    _ => {
      setSpinning(true)
      retrieveTask(apiTargetInfo).fork(setError, data => {
        setSpinning(false)
        clearData()
        const nd = data.map(d => ({
          ...d,
          oldDate: d.releaseUntil,
          releaseUntil: d.releaseUntil
            ? moment(d.releaseUntil).format('MM/DD/YYYY')
            : undefined,
        }))
        setData(nd)
      })
    },
    [apiTargetInfo, setError, setSpinning]
  )

  useEffect(
    _ => {
      onRetrieveData()
    },
    [onRetrieveData]
  )

  const editRow = editInfo => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          // modificationInfo: { user: null, modDate: moment() },
          modificationInfo: undefined,
          updated: true,
        }
      } else {
        return d
      }
    })
    let editData = editInfo.updated
    editData = editData.map(d => ({
      ...d,
      // modificationInfo: { user: null, modDate: moment() },
      modificationInfo: undefined,
    }))
    setData(modData)
    setEditInfo({ ...editInfo, updated: editData })
  }

  const modifiedDataForSave = data =>
    data.map(d => ({
      ...d,
      releaseUntil: moment(d.releaseUntil).format('YYYY-MM-DD'),
    }))

  const deleteData = _ => {
    if (selectedRows && selectedRows.length <= 0) {
      message.error('Please , Select Row to Delete')
      return
    }

    const sd = selectedRows.map(d => ({
      ...d,
      releaseUntil: moment(d.oldDate).format('YYYY-MM-DD'),
    }))

    setSpinning(true)
    deleteTask(apiTargetInfo)(sd).fork(setError, _ => {
      setSpinning(false)
      clearData()
      onRetrieveData()
    })
  }

  const saveData = _ => {
    let sd = freeEditEngine.applyEdits({
      data: data.filter(d => d.updated),
      editInfo,
    })
    sd = modifiedDataForSave(sd)
    setSpinning(true)
    modifyTask(apiTargetInfo)(sd).fork(setError, _ => {
      setSpinning(false)
      clearData()
      onRetrieveData()
    })
  }

  const adminPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: props.envConfig.authGodMode,
        actionPermits: props.actionPermits,
        eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [props.actionPermits, props.envConfig.authGodMode]
  )

  return (
    <div>
      <CriteriaRow style={{}}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '150px',
          }}
        >
          {title}
        </Title>

        <Button
          style={{}}
          onClick={onRetrieveData}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        {adminPermission && (
          <React.Fragment>
            <Button
              icon="plus-circle"
              loading={spinning}
              style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
              onClick={onInsert}
            >
              Insert
            </Button>
            <Button
              icon="edit"
              type="primary"
              onClick={saveData}
              style={{ marginLeft: '10px' }}
              disabled={selectedRows.length <= 0}
            >
              Update
            </Button>
            <Popconfirm
              title="Are you sure?"
              okText="Yes"
              cancelText="No"
              onConfirm={deleteData}
              // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
              placement="topRight"
              // disabled
            >
              <Button
                icon="delete"
                type="danger"
                // onClick={deleteData}
                style={{ marginLeft: '10px' }}
                disabled={selectedRows.length <= 0}
              >
                Remove
              </Button>
            </Popconfirm>
          </React.Fragment>
        )}

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={headerWithFormatter}
          fileName={title}
          btnStyle={{}}
          disabled={!!(data && data.length <= 0)}
        />
      </CriteriaRow>
      {insertEvent && (
        <CriteriaRow style={{ marginTop: '5px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 3fr 1fr 3fr 1fr 3fr',
              gridGap: '15px',
            }}
          >
            <TableTD>Utility :</TableTD>

            <Select
              id="utilitySelect"
              showSearch
              style={{ display: 'grid' }}
              value={insertData.utility}
              onChange={e =>
                setInsertData({
                  ...insertData,
                  utility: e,
                  unit: undefined,
                  unitId: undefined,
                })
              }
            >
              {R.sort(utilitysortOpt, Object.keys(props.utilityUnitMap)).map(
                e => (
                  <Select.Option value={e}>
                    {e} - {utilityNameMap[e]}
                  </Select.Option>
                )
              )}
            </Select>

            <TableTD>Unit :</TableTD>

            <Select
              id="UnitSelect"
              style={{ display: 'grid' }}
              value={insertData.unitId}
              onChange={e =>
                setInsertData({
                  ...insertData,
                  unitId: e,
                  unit:
                    e === 'ALL' ? 'ALL' : e.substr(insertData.utility.length),
                })
              }
            >
              <Select.Option value="ALL">ALL</Select.Option>
              {R.sort(
                unitsortOpt,
                props.utilityUnitMap[insertData.utility] || []
              ).map(e => (
                <Select.Option value={e}>
                  {e.substr(3)} - {unitNameMap[e]}
                </Select.Option>
              ))}
            </Select>

            <TableTD>Release Until :</TableTD>

            <DatePicker
              id="releaseUntil"
              style={{ width: '100%' }}
              onChange={date =>
                setInsertData({
                  ...insertData,
                  releaseUntil: date.format('YYYY-MM-DD'),
                  releaseUntilDate: date,
                  oldDate: date.format('YYYY-MM-DD'),
                })
              }
              date={insertData.releaseUntilDate}
              value={insertData.releaseUntilDate}
              placeholder="Release Until"
              format="MM/DD/YYYY"
              allowClear={false}
            />

            <TableTD>Lock Name :</TableTD>

            <Select
              id="lockName"
              style={{ display: 'grid' }}
              value={insertData.lockName}
              onChange={e => setInsertData({ ...insertData, lockName: e })}
            >
              {sortStringArray([
                ...monthlyLock,
                ...pjmVerificationLockList,
              ]).map(e => (
                <Select.Option value={e}>{e}</Select.Option>
              ))}
            </Select>
            <div />
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gridColumnGap: '10px',
                gridColumnEnd: 'span 1',
              }}
            >
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>

              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </CriteriaRow>
      )}
      <FullHeightSizer heightOffset={insertEvent ? 320 : 230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridRef}
              sortEnabled
              data={data}
              headers={headerWithFormatter}
              altBy={u => u.unit}
              altBgColor="#ebebeb"
              // onEditInfoChange={info => editRow(info)}
              // editInfo={editInfo}
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 60,
                width: width - 50,
                // cellRender: customizedCellRender,
                headerRowHeight: 30,
              })}
              fuzzyFilter={fuzzyFilter}
              isEditable={isEditable}
              onSelectionChange={rows => {
                selectionChange(rows)
              }}
              selectionMode="single"
              selectionType="cell"
              initialSortOptions={headers}
              editMode="cell"
              onEditInfoChange={editInfo => editRow(editInfo)}
              editInfo={editInfo}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )

  // return (
  //   <CommonScreen
  //     title={title}
  //     header={headerWithFormatter}
  //     saveTask={modifyTask}
  //     retrieveTask={retrieveTask}
  //     deleteTask={deleteTask}
  //     altBy={d => d.unitId}
  //     autoRetrieve
  //     sortOptions={[utilityHeader, unitIdHeader]}
  //     insertComp={insertEvent && insertComp}
  //     insertCompHeight={130}
  //     onInsertEvent={b => setInsertEvent(b)}
  //     headerRowHeight={30}
  //   />
  // )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(UnitLock)
